export const mediaList = [
  {
    id: 'm01',
    title: '星河远航',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20featuring%20a%20lone%20astronaut%20silhouette%20gazing%20toward%20a%20giant%20glowing%20planet%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20minimalist%20epic%20composition%2C%20highly%20detailed%20digital%20artwork&width=600&height=900&seq=cover-m01&orientation=portrait',
    director: '陈默',
    cast: ['吴宇航', '林静', '赵铭'],
    genres: ['科幻', '冒险'],
    region: '中国',
    year: 2024,
    updateDate: '2024-09-28',
    description:
      '一支深空考察队在遥远星系遭遇未知信号，人类文明的边界在一次远征中被重新定义。浩瀚星海中，他们必须在归途与真相之间做出抉择。',
    rating: 8.7,
    tags: ['科幻', '冒险', '太空'],
    episodes: '正片',
  },
  {
    id: 'm02',
    title: '暗涌之城',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%20of%20a%20rain%20soaked%20city%20street%20at%20night%20with%20a%20mysterious%20figure%20in%20a%20trench%20coat%2C%20deep%20navy%20and%20muted%20orange%20lighting%2C%20film%20noir%20atmosphere%2C%20cinematic%20minimalist%20composition%2C%20highly%20detailed%20artwork&width=600&height=900&seq=cover-m02&orientation=portrait',
    director: '李维',
    cast: ['周迅安', '韩雪', '陈昊'],
    genres: ['悬疑', '犯罪'],
    region: '中国',
    year: 2024,
    updateDate: '2024-09-20',
    description:
      '连环疑案背后隐藏着城市不为人知的暗面，一位固执的刑警循着蛛丝马迹追查真相，却发现每个人都握着一半的秘密。',
    rating: 8.4,
    tags: ['悬疑', '犯罪', '烧脑'],
    episodes: '正片',
  },
  {
    id: 'm03',
    title: '追光者',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20inspirational%20drama%20movie%20poster%20with%20a%20young%20figure%20walking%20toward%20a%20glowing%20sunrise%20on%20a%20mountain%20road%2C%20soft%20amber%20and%20deep%20blue%20tones%2C%20hopeful%20cinematic%20atmosphere%2C%20minimalist%20composition%2C%20highly%20detailed%20digital%20painting&width=600&height=900&seq=cover-m03&orientation=portrait',
    director: '王海',
    cast: ['刘思远', '张嘉'],
    genres: ['剧情'],
    region: '中国',
    year: 2023,
    updateDate: '2023-11-12',
    description:
      '一个普通乡村教师用十年光阴点亮一群孩子的梦想，平凡岁月里的坚持被时间酿成了最动人的光。',
    rating: 8.9,
    tags: ['剧情', '励志', '温情'],
    episodes: '正片',
  },
  {
    id: 'm04',
    title: '霓虹追凶',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=High%20energy%20action%20crime%20movie%20poster%20with%20a%20car%20chase%20through%20neon%20lit%20city%20at%20night%2C%20deep%20navy%20sky%20and%20bright%20orange%20neon%20reflections%2C%20dynamic%20cinematic%20composition%2C%20dramatic%20lighting%2C%20highly%20detailed%20digital%20artwork&width=600&height=900&seq=cover-m04&orientation=portrait',
    director: 'Ethan Cole',
    cast: ['Ryan Blake', 'Mia Ford'],
    genres: ['动作', '犯罪'],
    region: '美国',
    year: 2024,
    updateDate: '2024-08-30',
    description:
      '退役特工为救回被绑架的旧友，不得不重入霓虹闪烁的地下世界，一场速度与智谋的较量就此展开。',
    rating: 8.1,
    tags: ['动作', '犯罪', '飙车'],
    episodes: '正片',
  },
  {
    id: 'm05',
    title: '深海回声',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Atmospheric%20sci-fi%20mystery%20movie%20poster%20with%20deep%20ocean%20waves%20and%20glowing%20light%20beneath%20the%20surface%2C%20dark%20navy%20tones%20with%20subtle%20amber%20highlights%2C%20mysterious%20cinematic%20mood%2C%20minimalist%20composition%2C%20highly%20detailed%20artwork&width=600&height=900&seq=cover-m05&orientation=portrait',
    director: 'Sarah Miles',
    cast: ['Jake Brown', 'Emma Reed'],
    genres: ['科幻', '悬疑'],
    region: '美国',
    year: 2023,
    updateDate: '2023-10-05',
    description:
      '深海考察站捕捉到一段来自海沟深处的神秘回声，海洋学家在极端环境中逐渐逼近一个惊人的真相。',
    rating: 8.3,
    tags: ['科幻', '悬疑', '深海'],
    episodes: '正片',
  },
  {
    id: 'm06',
    title: '花期未至',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20with%20a%20couple%20under%20falling%20cherry%20blossoms%2C%20soft%20warm%20amber%20and%20gentle%20blue%20tones%2C%20dreamy%20cinematic%20atmosphere%2C%20elegant%20minimalist%20composition%2C%20highly%20detailed%20digital%20painting&width=600&height=900&seq=cover-m06&orientation=portrait',
    director: 'Park Jihoon',
    cast: ['Kim Sora', 'Lee Jun'],
    genres: ['爱情', '剧情'],
    region: '韩国',
    year: 2024,
    updateDate: '2024-07-18',
    description:
      '两个在花期错过的年轻人，用一整年的时间学着告别与重逢，爱情在最不经意的季节悄然绽放。',
    rating: 8.5,
    tags: ['爱情', '剧情', '治愈'],
    episodes: '正片',
  },
  {
    id: 'm07',
    title: '喜马拉雅之巅',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20adventure%20movie%20poster%20of%20snow%20covered%20Himalayan%20peaks%20with%20a%20tiny%20climber%2C%20deep%20blue%20shadows%20and%20golden%20sunrise%20light%2C%20grand%20cinematic%20scale%2C%20minimalist%20composition%2C%20highly%20detailed%20digital%20artwork&width=600&height=900&seq=cover-m07&orientation=portrait',
    director: '张峰',
    cast: ['王磊', '李娜'],
    genres: ['冒险', '剧情'],
    region: '中国',
    year: 2022,
    updateDate: '2022-12-01',
    description:
      '一支登山队向世界之巅发起挑战，在极限环境中，人与山、人与同伴的羁绊被风雪反复考验。',
    rating: 8.6,
    tags: ['冒险', '剧情', '登山'],
    episodes: '正片',
  },
  {
    id: 'm08',
    title: '时间裂缝',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20with%20a%20glowing%20time%20portal%20splitting%20a%20dark%20cityscape%2C%20deep%20navy%20tones%20and%20electric%20orange%20energy%2C%20dramatic%20cinematic%20composition%2C%20futuristic%20minimalist%20style%2C%20highly%20detailed%20digital%20artwork&width=600&height=900&seq=cover-m08&orientation=portrait',
    director: 'Oliver Grant',
    cast: ['James Hale', 'Lucy Wade'],
    genres: ['科幻'],
    region: '英国',
    year: 2024,
    updateDate: '2024-06-22',
    description:
      '一次实验意外撕开时间裂缝，物理学家必须在平行时空彻底崩坏之前，找到唯一正确的那个选择。',
    rating: 8.2,
    tags: ['科幻', '时空', '烧脑'],
    episodes: '正片',
  },
  {
    id: 't01',
    title: '长安十二辰',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20poster%20featuring%20a%20historic%20city%20at%20dusk%20with%20silhouettes%20of%20guards%2C%20deep%20navy%20sky%20and%20warm%20lantern%20orange%20glow%2C%20cinematic%20epic%20atmosphere%2C%20elegant%20detailed%20artwork&width=600&height=900&seq=cover-t01&orientation=portrait',
    director: '郭靖',
    cast: ['沈川', '苏语', '孟河'],
    genres: ['古装', '悬疑'],
    region: '中国',
    year: 2024,
    updateDate: '2024-10-02',
    description:
      '繁华长安城暗流涌动，一位小吏在上元节前的十二个时辰里，抽丝剥茧揭开一场即将爆发的惊天阴谋。',
    rating: 9.1,
    tags: ['古装', '悬疑', '权谋'],
    episodes: '全 36 集',
  },
  {
    id: 't02',
    title: '迷雾航线',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Suspense%20drama%20series%20poster%20with%20a%20foggy%20coastal%20harbor%20and%20a%20lone%20ship%2C%20deep%20navy%20tones%20and%20faint%20amber%20light%2C%20moody%20cinematic%20atmosphere%2C%20minimalist%20composition%2C%20highly%20detailed%20digital%20artwork&width=600&height=900&seq=cover-t02&orientation=portrait',
    director: '何雨',
    cast: ['林深', '方茴'],
    genres: ['悬疑', '都市'],
    region: '中国',
    year: 2024,
    updateDate: '2024-09-16',
    description:
      '一艘消失多年的货轮突然重现海面，牵出一段被刻意掩埋的往事，调查记者只身驶入层层迷雾之中。',
    rating: 8.6,
    tags: ['悬疑', '都市', '推理'],
    episodes: '更新至 18 集',
  },
  {
    id: 't03',
    title: '都市浮生记',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Urban%20drama%20series%20poster%20with%20modern%20city%20skyline%20at%20night%20and%20silhouettes%20in%20an%20apartment%20window%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20reflective%20cinematic%20mood%2C%20detailed%20digital%20artwork&width=600&height=900&seq=cover-t03&orientation=portrait',
    director: '陈可',
    cast: ['顾城', '安然', '陆宁'],
    genres: ['都市', '剧情'],
    region: '中国',
    year: 2023,
    updateDate: '2023-12-20',
    description:
      '五个合租在旧城区的年轻人，在房价、职场与情感的夹缝中努力生活，书写属于他们的浮世篇章。',
    rating: 8.3,
    tags: ['都市', '剧情', '生活'],
    episodes: '全集',
  },
  {
    id: 't04',
    title: '王的抉择',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Historical%20royal%20drama%20poster%20featuring%20a%20grand%20throne%20hall%20with%20dramatic%20light%20shafts%2C%20deep%20navy%20and%20gold%20amber%20tones%2C%20cinematic%20epic%20atmosphere%2C%20elegant%20detailed%20digital%20artwork&width=600&height=900&seq=cover-t04&orientation=portrait',
    director: 'Henry Cole',
    cast: ['Edward Barnes', 'Clara Webb'],
    genres: ['历史', '剧情'],
    region: '英国',
    year: 2024,
    updateDate: '2024-08-08',
    description:
      '一位年轻君主在权力、亲情与责任之间艰难权衡，每一次抉择都将改写整个王国的命运走向。',
    rating: 8.8,
    tags: ['历史', '剧情', '权谋'],
    episodes: '全 24 集',
  },
  {
    id: 't05',
    title: '心动信号',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20with%20soft%20pastel%20city%20lights%20and%20two%20figures%20almost%20touching%20hands%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20tender%20cinematic%20atmosphere%2C%20elegant%20minimalist%20artwork&width=600&height=900&seq=cover-t05&orientation=portrait',
    director: 'Choi Min',
    cast: ['Han Yuna', 'Seo Jun'],
    genres: ['爱情', '都市'],
    region: '韩国',
    year: 2024,
    updateDate: '2024-09-10',
    description:
      '一段始于误会、终于心动的都市恋情，两个习惯独处的人在彼此的日常里，慢慢读懂了陪伴的意义。',
    rating: 8.4,
    tags: ['爱情', '都市', '甜宠'],
    episodes: '更新至 12 集',
  },
  {
    id: 't06',
    title: '硅谷风云',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Tech%20workplace%20drama%20poster%20with%20a%20modern%20glass%20office%20at%20night%20and%20glowing%20screens%2C%20deep%20navy%20tones%20and%20amber%20accent%20lighting%2C%20sleek%20cinematic%20mood%2C%20detailed%20digital%20artwork&width=600&height=900&seq=cover-t06&orientation=portrait',
    director: 'Alex Reed',
    cast: ['Daniel Frost', 'Grace Lin'],
    genres: ['都市', '剧情'],
    region: '美国',
    year: 2023,
    updateDate: '2023-11-28',
    description:
      '一家初创公司在资本与理想之间反复摇摆，创始团队在高速扩张中直面信任、野心与初心的考验。',
    rating: 8.2,
    tags: ['都市', '职场', '剧情'],
    episodes: '全集',
  },
  {
    id: 't07',
    title: '山野医仙',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Fantasy%20costume%20drama%20poster%20featuring%20a%20mystical%20mountain%20village%20with%20glowing%20herbs%20and%20mist%2C%20deep%20blue%20tones%20and%20warm%20amber%20magic%20light%2C%20enchanting%20cinematic%20atmosphere%2C%20detailed%20digital%20artwork&width=600&height=900&seq=cover-t07&orientation=portrait',
    director: '柳青',
    cast: ['白芷', '陆离'],
    genres: ['古装', '奇幻'],
    region: '中国',
    year: 2024,
    updateDate: '2024-10-06',
    description:
      '隐居深山的少年药童意外继承了失传医典，走出山野踏入红尘，以仁心妙手卷入门派与朝堂的纷争。',
    rating: 8.5,
    tags: ['古装', '奇幻', '中医'],
    episodes: '更新至 22 集',
  },
  {
    id: 't08',
    title: '隐秘的角落之外',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Crime%20suspense%20series%20poster%20with%20a%20shadowy%20alley%20and%20a%20single%20street%20lamp%20glow%2C%20deep%20navy%20darkness%20and%20amber%20light%2C%20tense%20cinematic%20atmosphere%2C%20minimalist%20detailed%20artwork&width=600&height=900&seq=cover-t08&orientation=portrait',
    director: '辛阳',
    cast: ['秦川', '夏彤', '周野'],
    genres: ['悬疑', '犯罪'],
    region: '中国',
    year: 2022,
    updateDate: '2022-09-15',
    description:
      '一件尘封十年的旧案重见天日，当年的三个当事人如今各怀心事，真相在重逢之夜被一层层剥开。',
    rating: 8.7,
    tags: ['悬疑', '犯罪', '烧脑'],
    episodes: '全集',
  },
  {
    id: 't09',
    title: '未来纪元',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20series%20poster%20with%20a%20towering%20smart%20city%20and%20flying%20vehicles%2C%20deep%20navy%20sky%20and%20orange%20neon%20accents%2C%20grand%20cinematic%20composition%2C%20highly%20detailed%20digital%20artwork&width=600&height=900&seq=cover-t09&orientation=portrait',
    director: '韩枫',
    cast: ['沈墨', '纪云'],
    genres: ['科幻', '剧情'],
    region: '中国',
    year: 2024,
    updateDate: '2024-09-30',
    description:
      '在人工智能深度参与治理的未来都市，一群人试图探寻技术与人性的边界，谱写属于新时代的纪元传说。',
    rating: 8.6,
    tags: ['科幻', '剧情', '未来'],
    episodes: '更新至 15 集',
  },
  {
    id: 'v01',
    title: '奔跑吧少年',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Energetic%20variety%20show%20poster%20with%20young%20people%20running%20across%20a%20colorful%20open%20field%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20joyful%20dynamic%20composition%2C%20vibrant%20detailed%20illustration&width=600&height=900&seq=cover-v01&orientation=portrait',
    director: '综艺制作组',
    cast: ['常驻嘉宾团'],
    genres: ['真人秀'],
    region: '中国',
    year: 2024,
    updateDate: '2024-10-08',
    description:
      '一群年轻人走出城市，在户外完成任务挑战，用汗水与笑料记录下独属于青春的奔跑时光。',
    rating: 8.0,
    tags: ['真人秀', '户外', '青春'],
    episodes: '更新至 第 8 期',
  },
  {
    id: 'v02',
    title: '声临其境巅峰',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Music%20reality%20show%20poster%20with%20a%20glowing%20microphone%20on%20a%20dark%20stage%20and%20light%20beams%2C%20deep%20navy%20tones%20and%20warm%20amber%20spotlight%2C%20dramatic%20cinematic%20atmosphere%2C%20detailed%20artwork&width=600&height=900&seq=cover-v02&orientation=portrait',
    director: '综艺制作组',
    cast: ['实力唱将团'],
    genres: ['音乐'],
    region: '中国',
    year: 2024,
    updateDate: '2024-10-04',
    description:
      '顶级歌手同台竞演，用声音重新演绎经典作品，每一期都是一场直击心灵的沉浸式音乐盛宴。',
    rating: 8.3,
    tags: ['音乐', '竞演', '现场'],
    episodes: '更新至 第 6 期',
  },
  {
    id: 'v03',
    title: '舌尖上的旅程',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Food%20travel%20documentary%20poster%20with%20steaming%20regional%20dishes%20under%20warm%20lantern%20light%2C%20deep%20blue%20background%20and%20amber%20glow%2C%20appetizing%20cinematic%20composition%2C%20highly%20detailed%20artwork&width=600&height=900&seq=cover-v03&orientation=portrait',
    director: '美食纪录组',
    cast: ['美食探访团'],
    genres: ['美食'],
    region: '中国',
    year: 2023,
    updateDate: '2023-10-18',
    description:
      '循着时令与风土的脉络走访大江南北，在每一道家常菜背后，聆听土地与人情交织的动人故事。',
    rating: 8.9,
    tags: ['美食', '纪实', '人文'],
    episodes: '全集',
  },
  {
    id: 'v04',
    title: '舞台之王',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Talent%20competition%20show%20poster%20with%20a%20bright%20stage%20and%20a%20spotlit%20performer%20silhouette%2C%20deep%20navy%20tones%20and%20vivid%20amber%20stage%20lights%2C%20dramatic%20energetic%20composition%2C%20detailed%20artwork&width=600&height=900&seq=cover-v04&orientation=portrait',
    director: 'Stage Lab',
    cast: ['练习生团队'],
    genres: ['选秀'],
    region: '韩国',
    year: 2024,
    updateDate: '2024-09-26',
    description:
      '来自各地的年轻追梦者汇聚舞台，经历层层竞演与蜕变，只为争夺那个光芒万丈的出道席位。',
    rating: 8.1,
    tags: ['选秀', '舞台', '青春'],
    episodes: '更新至 第 10 期',
  },
  {
    id: 'v05',
    title: '极限挑战营',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20challenge%20variety%20show%20poster%20with%20contestants%20on%20a%20rugged%20mountain%20course%2C%20warm%20amber%20daylight%20and%20deep%20blue%20sky%2C%20adventurous%20energetic%20composition%2C%20detailed%20illustration&width=600&height=900&seq=cover-v05&orientation=portrait',
    director: '综艺制作组',
    cast: ['挑战家族'],
    genres: ['真人秀'],
    region: '中国',
    year: 2024,
    updateDate: '2024-10-01',
    description:
      '嘉宾团队在极限环境中完成高难度任务，用勇气、默契与智慧，一次次突破看似不可能的挑战。',
    rating: 7.9,
    tags: ['真人秀', '竞技', '户外'],
    episodes: '更新至 第 7 期',
  },
  {
    id: 'v06',
    title: '脱口秀之夜',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Comedy%20talk%20show%20poster%20with%20a%20microphone%20on%20a%20stool%20under%20a%20warm%20spotlight%2C%20deep%20navy%20background%20and%20amber%20glow%2C%20playful%20cinematic%20mood%2C%20minimalist%20detailed%20artwork&width=600&height=900&seq=cover-v06&orientation=portrait',
    director: '喜剧工坊',
    cast: ['脱口秀演员团'],
    genres: ['喜剧'],
    region: '中国',
    year: 2024,
    updateDate: '2024-10-05',
    description:
      '一群脱口秀演员用幽默解构生活日常，在笑声中与你聊聊那些藏在平凡里的小确幸与小烦恼。',
    rating: 8.2,
    tags: ['喜剧', '语言', '生活'],
    episodes: '更新至 第 5 期',
  },
  {
    id: 'v07',
    title: '野性星球',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20of%20a%20wild%20savanna%20at%20golden%20hour%20with%20distant%20wildlife%20silhouettes%2C%20deep%20blue%20sky%20and%20amber%20sunset%20tones%2C%20majestic%20cinematic%20composition%2C%20highly%20detailed%20artwork&width=600&height=900&seq=cover-v07&orientation=portrait',
    director: 'Wild Unit',
    cast: ['自然摄制组'],
    genres: ['纪录片'],
    region: '英国',
    year: 2023,
    updateDate: '2023-08-20',
    description:
      '镜头深入人迹罕至的自然秘境，记录野生动物的生存智慧与壮丽地貌，呈现一颗鲜活而野性的星球。',
    rating: 9.2,
    tags: ['纪录片', '自然', '科普'],
    episodes: '全集 6 集',
  },
];